<template>
  <div>
    <div class="grid-item grid-item-data cart-item">
      <div class="articul">
        <a class="hide-desktop fav-code" href="#" @click.prevent="switchFavourite">
          <i class="svg-icon star" :class="{'star-favourite': isFavourite}" />
        </a>
        
        <span>{{ product.code }}</span>
        
        <!-- <span>{{ product.brand_name }}</span> -->

        <div class="hide-desktop fav-code del-item">
          <a class="circle" href="#" @click.prevent="deleteCart()">
            <i class="svg-icon cross-little icon-pointer" />
          </a>
        </div>
      </div>

      <div class="brand">
        <div class="title-col hide-desktop">{{ $t('brand') }}</div>
        <div>{{ product.brand_name }}</div>
      </div>

      <div class="name">
        <nuxt-link 
          class="link-ext"
          :to="localePath('/product/' + product.slug)"
        >
          {{ productLocaleData.name }}
        </nuxt-link>
      </div>

      <div class="store store_name">
        <div class="title-col hide-desktop">{{ $t('stock') }}</div>
        <div
          class="stock-supplier"
          :class="{'pointer dashed-bottom': supplier.stock.shipment_days > 0}" 
          @mouseover="showSupplier = !showSupplier"
          @mouseleave="showSupplier = false"
        >
          {{ stockLocaleDataName }}

          <transition name="fade">
            <div v-if="supplier.stock.shipment_days > 0 && showSupplier" class="tooltip">
              <span>
                {{ deliveryDeadline(supplier.stock.shipment_days_limit) }}
                {{ supplier.stock.shipment_days }}
                {{ supplier.stock.shipment_days | ending([$t('day_1'), $t('day_2'), $t('day_3')], $i18n.locale) }}
              </span>
            </div>
          </transition>
        </div>
      </div>

      <div class="store store_qnt">
        <div class="title-col hide-desktop">{{ $t('store_pcs') }}</div>
        <div class="stock-supplier">
          <span
            :class="{'pointer dashed-bottom': supplier.stock.shipment_days > 0}"
            @mouseover="showSupplierAvail = !showSupplierAvail"
            @mouseleave="showSupplierAvail = false"
          >{{ supplier.amount_free | integerPart }}</span>
          
          <!-- TODO: временно отключено, use .dashed -->
          <!-- <transition name="fade">
            <div v-if="showSupplierAvail" class="tooltip">
              <span> {{ $t('amount_updated_date') }} {{ supplier.amount_free_updated | formatDate }}</span>
            </div>
          </transition> -->
        </div>
      </div>

      <div class="price">
        <div class="title-col hide-desktop">{{ $t('price_rub') }}</div>
        <div>
          <template v-if="productAmount >= product.discount_min_qnt && getDiscountRate(product) !== 1">
            <div class="price-discounted">
              {{ getPrice(supplier, product) | integerPart }}
              <span class="small">{{ getPrice(supplier, product) | fractionalPart }}</span>
            </div>
            <div class="price-old">
              <span class="price-old_value">
                {{ getPrice(supplier, product) | integerPart }}<span class="small">{{ getPrice(supplier, product) | fractionalPart }}</span>
              </span>
              <span class="price-old_discount">
                {{ -1 * product.discount_value }}%
              </span>
            </div>
          </template>
          <template v-else>
            {{ getPrice(supplier, product) | integerPart }}
            <span class="small">{{ getPrice(supplier, product) | fractionalPart }}</span>
          </template>
        </div>
      </div>
      
      <div class="order order-qnt-edit">
        <div class="link-tooltip">
          <a href="#" @click.prevent="decreaseAmount"><i class="svg-icon minus icon-pointer" /></a>
          <input-number v-model="amountCart" :value="amountCart" :min-value="0" />
          <a href="#" @click.prevent="increaseAmount"><i class="svg-icon plus icon-pointer" /></a>
          <a 
            class="button-ok" 
            :class="{'hidden': amountCart === productAmount}" 
            href="#"
            @click.prevent="updateAmount"
          >OK</a>
        </div>
      </div>

      <div class="total">
        <div class="title-col hide-desktop">{{ $t('sum_rub') }}</div>

        <span class="text-align-center">
          {{ totalPrice | integerPart }}<span class="small">{{ totalPrice | fractionalPart }}</span>
        </span>
        
        <div class="hide-phone del-item text-align-right">
          <a class="circle" href="#" @click.prevent="deleteCart()">
            <i class="svg-icon cross-little icon-pointer" />
          </a>
        </div>
      </div>

      <div
        class="discount-item increase-qnt"
        v-if="product.discount_value > 0 && product.discount_min_qnt > productAmount"
      >
        <span>
          {{ $t('to_apply_discount').replace(
            '{discount}', product.discount_value
          ).replace(
            '{min_qnt}', product.discount_min_qnt
          ) }}
        </span>
        <span class="popup-container" :class="{ 'active': discountDescrVisible }">
          <i class="svg-icon info" @click="discountDescrVisible = !discountDescrVisible" v-show="!discountDescrVisible"/>
          <i class="svg-icon cross-little" @click="discountDescrVisible = !discountDescrVisible" v-show="discountDescrVisible"/>
          <div class="popup-content" v-show="discountDescrVisible">
            <site-text-block type="discount_descr" class="discount_descr" />
          </div>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import {ProductFavourite} from "@/models/product";

import InputNumber from '@/components/controls/input-number';
import SiteTextBlock from '@/components/blocks/site-text-block';

const TOOLTIP_TIMEOUT = 5000;

export default {
  components: {
    InputNumber,
    SiteTextBlock,
  },
  props: [
    'product',
    'stocks',
    'supplier'
  ],
  data() {
    return {
      showSupplier: false,
      showSupplierAvail: false,
      amountStock: 0,
      amountCart: 0,
      showDeleteDialog: false,
      isFavourite: false,
      showTooltipQnt: false,
      timerTooltopQnt: null,
      enableTooltipQnt: true,
      discountDescrVisible: false,
    }
  },
  watch: {
    'discountDescrVisible'(value) {
      if (value) {
        this.discountDescrTimer = setTimeout(() => this.discountDescrVisible = false, TOOLTIP_TIMEOUT)
      } else {
        clearTimeout(this.discountDescrTimer);
      }
    },
  },
  computed: {
    productLocaleData() {
      return this.product?.product_translations?.find(x => x.language.slug === this.$i18n.locale) || {};
    },
    stockLocaleDataName() {
      return this.supplier?.stock.stock_translations?.find(x => x.language.slug === this.$i18n.locale)?.name || this.supplier?.stock.name_1c || {};
    },
    productAmount() {
      return this.supplier.amount_cart
      // return Object.values(this.product.amount_cart).reduce((a, b) => a + b, 0);
    },
    totalPrice() {
      let sum = this.productAmount * this.getPrice(this.supplier, this.product);
      // if (sum % 1 === 0) {
      //   sum = parseInt(sum);
      // }
      return sum;
    },
  },
  created() {
    this.isFavourite = this.product.is_favourite;
    this.amountCart = this.productAmount;
    this.amountStock = this.supplier.amount_free;
    this.enableTooltipQnt = this.amountStock >= this.amountCart
  },
  methods: {
    getPrice(supplier, product) {
      let res = supplier.price;
      if(this.getDiscountRate(product) !== 1){
        res = parseInt(res * this.getDiscountRate(product));
      }
      return res;
    },
    getDiscountRate(product) {
      let rate = 1;
      if (this.productAmount >= product.discount_min_qnt) {
        return (100 - product.discount_value) / 100;
      }
      return rate;
    },
    deliveryDeadline(dl){
      if (dl === 'gt'){
        return this.$t('delivery_deadline_from') 
      }
      else if (dl === 'lt'){
        return this.$t('delivery_deadline_to') 
      }
      return this.$t('delivery_deadline') 
    },
    checkQnt(){
      if(this.enableTooltipQnt){
        this.showTooltipQnt = this.amountCart > this.amountStock
        clearTimeout(this.timerTooltopQnt);
        this.timerTooltopQnt = setTimeout(()=>this.showTooltipQnt=false, TOOLTIP_TIMEOUT)
      }
    },
    decreaseAmount() {
      if (this.amountCart > this.product.package_quantity) {
        let amount = this.amountCart - this.product.package_quantity;
        if (amount % this.product.package_quantity) {
          amount += this.product.package_quantity - amount % this.product.package_quantity;
        }
        this.amountCart = amount;
        // this.updateAmount();
      }
      this.checkQnt();
    },
    increaseAmount() {
      let amount = this.amountCart + this.product.package_quantity;
      amount -= amount % this.product.package_quantity;
      this.amountCart = amount;
      // this.updateAmount();
      this.checkQnt();
    },
    updateAmount() {
      const data = {
        product: this.product.id,
        amount: this.amountCart,
        supplier: this.supplier.stock.id,
        price: this.supplier.price || this.product.price,
        replace_cart: 1,
      };
      // this.$axios.$post('/order/add-cart-supplier/', data).then((response) => {
      this.$axios.$post('/order/update-cart/', data).then((response) => {
        this.$emit('fetch-cart');
        this.showTooltipQnt = false;
        this.enableTooltipQnt = this.amountStock >= this.amountCart;
        this.amountCart = response.amount_cart;
      }).catch((e) => {
        this.amountCart = this.productAmount;
        try {
          this.$notify({
            duration: 5000,
            text: e.response.data.detail || e.response.data.amount[0],
            ignoreDuplicates: true,
          });
        } catch (e) {
        }
      });
    },
    deleteCart() {
      const data = {
        product: this.product.id,
        supplier: this.supplier.stock.id,
      };
      this.$axios.$post('/order/user-order/cart-delete/', data).then((response) => {
        this.$store.dispatch('setCartExists');
        this.$emit('fetch-cart');
      }).catch((e) => {
        try {
          this.$notify({
            duration: 5000,
            text: e.response.data.detail,
            ignoreDuplicates: true,
          });
        } catch (e) {
        }
      }).finally(() => {
        this.showDeleteDialog = false;
      });
    },
    switchFavourite() {
      if (this.$auth.loggedIn) {
        let fav = new ProductFavourite({product: this.product.id});
        if (this.isFavourite) {
          fav.id = this.product.id;
          fav.delete().then(() => {
            this.$store.dispatch('setFavouriteProductsExists');
            this.isFavourite = false;
            this.$notify({
              duration: 1000,
              text: this.$t('product_removed_from_fav'),
            });
            this.$emit('remove-favourite');
          });
        } else {
          fav.save().then(() => {
            this.$store.dispatch('setFavouriteProductsExists');
            this.isFavourite = true;
            this.$notify({
              duration: 1000,
              text:
                `${this.$t('product_added_to_fav_1')} <a href="${this.localePath('/profile/orders/')}">${this.$t('product_added_to_fav_2')}</a>`,
            });
          });
        }
      }
    },
  },
}
</script>

<i18n lang="yaml">
ru:
  preorder: 'под заказ'
  quantity_pcs: 'Количество шт.'
  delete_product_confirm_1: 'Вы уверены, что хотите удалить этот товар?'
  delete_product_confirm_2: 'Подтвердите действие!'
  delete: 'Удалить'
  product_added_to_fav_1: 'Товар добавлен в избранное. В избранное можно перейти в'
  product_added_to_fav_2: 'личном кабинете'
  product_removed_from_fav: 'Товар удален из избранного.'
  remote: 'Производство'
en:
  preorder: 'preorder'
  quantity_pcs: 'Quantity, pcs.'
  delete_product_confirm_1: 'Are you sure you want to delete this product?'
  delete_product_confirm_2: 'Confirm action!'
  delete: 'Delete'
  product_added_to_fav_1: 'Product is added to favourites. You can view favourite products in'
  product_added_to_fav_2: 'personal account'
  product_removed_from_fav: 'Product is removed from favourites.'
  remote: 'Remote stock'
</i18n>
